import styled from "styled-components";

import { SPACING } from "../../../utils/constants";

export const InspectableChart = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  min-width: 0;
`;

export const Inspector = styled.div`
  width: 100%;
  border-radius: 8px;
  touch-action: pan-y;

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 4px;
  }
`;

export const Readout = styled.p`
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  column-gap: ${SPACING.lg}px;
  row-gap: ${SPACING.xs}px;
  font-size: var(--text-base);
  color: var(--color-text-secondary);
  font-variant-numeric: tabular-nums;
`;

export const ReadoutDate = styled.span`
  font-weight: 700;
  color: var(--color-text-default);
`;
